import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import CloseIcon from '../../../icons/close.svg';

const Header = ({
  current, size, occupation, business, handleClose
}) => (
  <div className={styles.header}>
    <div className={styles.row}>
      <p className={styles.step}>{`Step ${current} of ${size - 1}`}</p>
      <button type="button" onClick={handleClose} className={styles.close}>
        <CloseIcon />
      </button>
    </div>
    <p className={styles.occupation}>{`${occupation} service request`}</p>
    <p className={styles.business}>{business}</p>
  </div>
);

Header.propTypes = {
  current: PropTypes.number,
  size: PropTypes.number,
  occupation: PropTypes.string,
  business: PropTypes.string,
  handleClose: PropTypes.func
};

export default Header;
